'use strict';

var _ = require('lodash');
var StrategyConditionController = function StrategyConditionController($scope, strategyRecordService, strategyConditionDataService, CommonUiConstants, StrategyConstants, urdConditionSerializerService, bookingsIntakeSerializerService, configurationService) {
  $scope.selectCondition = function () {
    $scope.changeSelectedRow($scope.condition, 'conditions');
  };
  $scope.isUrdCategory = function () {
    return urdConditionSerializerService.isUrdCategory($scope.condition.category);
  };
  $scope.isBookingsIntake = function () {
    return bookingsIntakeSerializerService.isBookingsIntakeCriterion($scope.condition.criterion);
  };
  $scope.isBookingsPercentIntake = function () {
    return bookingsIntakeSerializerService.isBookingsIntakePercentCriterion($scope.condition.criterion);
  };
  $scope.quantifiers = StrategyConstants.Quantifiers;
  $scope.validationMessage = 'Invalid entry';
  $scope.integerWarning = 'The value must be an integer';
  $scope.startDateIsAfterEndDate = 'Start date should be before or equal to end date';
  $scope.endDateIsBeforeStartDate = 'End date should be after or equal to start date';
  $scope.invalidDate = 'The value must be a valid date.';
  var selectedCategory = $scope.condition.category;
  var selectedCriterion = $scope.condition.criterion;
  var selectedOperator = $scope.condition.operator;
  var conditionName = StrategyConstants.CONDITION;
  $scope.categories = strategyRecordService.getCategories(conditionName, $scope.level, $scope.activeEntityType, $scope.flowType);
  $scope.criteria = strategyRecordService.getCriteria(conditionName, $scope.level, $scope.activeEntityType, $scope.flowType, selectedCategory);
  $scope.operators = strategyRecordService.getOperators(conditionName, $scope.level, $scope.activeEntityType, selectedCategory, selectedCriterion);
  $scope.valueType = strategyRecordService.getValueType(conditionName, $scope.level, $scope.activeEntityType, selectedCategory, selectedCriterion, selectedOperator);
  $scope.pattern = strategyRecordService.getPattern(conditionName, $scope.level, $scope.activeEntityType, selectedCategory, selectedCriterion, selectedOperator);
  function fillOperandData() {
    $scope.leftOperandData = strategyConditionDataService.getOperandData($scope.condition.field);
    $scope.urdFunctionTypeData = $scope.isUrdCategory() ? StrategyConstants.DROP_DOWN_DATA.urdFunctionTypeOptions : null;
    $scope.daysOffsetsData = $scope.isBookingsIntake() ? configurationService.getDefaultDaysOffsets().map(String) : null;
    $scope.daysOffsetsPercentData = $scope.isBookingsPercentIntake() ? configurationService.getDefaultDaysOffsets().map(String) : null;
  }
  fillOperandData();
  $scope.FLOAT_PERSISTENCE_PATTERN = function () {
    return {
      test: function test(value) {
        switch ($scope.condition.precision) {
          case 2:
            return CommonUiConstants.FLOAT_PERSISTENCE_2_PATTERN.test(value);
          case 3:
            return CommonUiConstants.FLOAT_PERSISTENCE_3_PATTERN.test(value);
        }
        return CommonUiConstants.FLOAT_PATTERN.test(value);
      }
    };
  }();
  $scope.INT_PATTERN = CommonUiConstants.INT_PATTERN;
  $scope.POSITIVE_INT_PATTERN = CommonUiConstants.POSITIVE_INT_PATTERN;
  $scope.FLOAT_PATTERN = CommonUiConstants.FLOAT_PATTERN;
  $scope.POSITIVE_FLOAT_PERSISTENCE_2_PATTERN = CommonUiConstants.POSITIVE_FLOAT_PERSISTENCE_2_PATTERN;
  function clearModel(withOperator, withCriteria) {
    $scope.condition.leftOperand = null;
    $scope.condition.rightOperand = null;
    $scope.condition.field = null;
    $scope.condition.metaCategory = null;
    if (withCriteria) {
      $scope.condition.criterion = null;
    }
    if (withOperator) {
      $scope.condition.operator = null;
    }
  }
  $scope.onCategoryChange = function () {
    $scope.criteria = strategyRecordService.getCriteria(conditionName, $scope.level, $scope.activeEntityType, $scope.flowType, $scope.condition.category);
    $scope.condition.isFieldValueRequired = strategyRecordService.getIsFieldValueRequired(conditionName, $scope.level, $scope.activeEntityType, $scope.condition.category);
    $scope.operators = null;
    clearModel(true, true);
  };
  $scope.onCriteriaChange = function () {
    $scope.operators = strategyRecordService.getOperators(conditionName, $scope.level, $scope.activeEntityType, $scope.condition.category, $scope.condition.criterion);
    $scope.field = strategyRecordService.getField(conditionName, $scope.level, $scope.activeEntityType, $scope.condition.category, $scope.condition.criterion);
    $scope.metaCategory = strategyRecordService.getMetaCategory(conditionName, $scope.level, $scope.activeEntityType, $scope.condition.category, $scope.condition.criterion);
    clearModel(true);
    if ($scope.operators.length > 0) {
      $scope.condition.operator = $scope.operators[0];
      $scope.onOperatorChange();
    }
    $scope.condition.field = $scope.field;
    $scope.condition.metaCategory = $scope.metaCategory;
  };
  $scope.onOperatorChange = function () {
    $scope.valueType = strategyRecordService.getValueType(conditionName, $scope.level, $scope.activeEntityType, $scope.condition.category, $scope.condition.criterion, $scope.condition.operator);
    $scope.field = strategyRecordService.getField(conditionName, $scope.level, $scope.activeEntityType, $scope.condition.category, $scope.condition.criterion);
    $scope.metaCategory = strategyRecordService.getMetaCategory(conditionName, $scope.level, $scope.activeEntityType, $scope.condition.category, $scope.condition.criterion);
    $scope.condition.precision = strategyRecordService.getPrecision(conditionName, $scope.level, $scope.activeEntityType, $scope.condition.category, $scope.condition.criterion, $scope.condition.operator);
    $scope.pattern = strategyRecordService.getPattern(conditionName, $scope.level, $scope.activeEntityType, $scope.condition.category, $scope.condition.criterion, $scope.condition.operator);
    clearModel();
    $scope.condition.field = $scope.field;
    $scope.condition.metaCategory = $scope.metaCategory;
    fillOperandData();
  };
  $scope.isRightOperandVisible = function () {
    return $scope.condition && $scope.condition.operator && $scope.valueType && _.startsWith($scope.valueType, '2');
  };
};
StrategyConditionController.$inject = ['$scope', 'StrategyRecordService', 'StrategyConditionDataService', 'CommonUiConstants', 'StrategyConstants', 'UrdConditionSerializerService', 'BookingsIntakeSerializerService', 'ConfigurationService'];
module.exports = StrategyConditionController;